import { combineReducers } from "redux";
import personalLending from "./personal-lending-reducer"
import customer from "./customer-reducer"
import loanReducer from "./loan-reducer"
import utilReducer from "./util-reducer"
import auth from './auth-reducer';
import multiplik from './multiplik-reducer';
import application from "./application-reducer"

export default combineReducers({
  personalLending,
  customer,
  loanReducer,
  utilReducer,
  auth,
  multiplik,
  application,
});
